<template>
    <div :class="['modal-container', show ? 'active' : '']">
      <div class="card head-card news modalCharts">
        <div class="title-card">
          <h4>Compartir</h4>
          <button class="touchpad" @click="cancelar">X</button>
        </div>
        <div class="card-content text-center">  
            <div class="row justify-content-center">
                <div class="col-sm-12 col-md-3 ">
                    <button class="btn-redondo" @click="share('E')" >
                        <font-awesome-icon icon="envelope" />
                    </button>  
                </div>
                <!--<div class="col-sm-12 col-md-3" >
                    <button class="btn-redondo twitter" @click="share('TW')">
                        <font-awesome-icon :icon="['fab','twitter']" />
                    </button>  
                </div>
                <div class="col-sm-12 col-md-3" >
                    <button class="btn-redondo facebook" @click="share('FB')">
                        <font-awesome-icon :icon="['fab','facebook-f']" />
                    </button>        
                </div>-->
                <div class="col-sm-12 col-md-3" >
                    <button class="btn-redondo whats" @click="share('W')" >
                        <font-awesome-icon :icon="['fab','whatsapp']" />
                    </button>        
                </div>
            </div> 
        </div>
      </div>
    </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTwitter, faFacebookF, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";


library.add(faTwitter);
library.add(faFacebookF);
library.add(faWhatsapp);
library.add(faEnvelope);



export default {
    name: 'sharBox',
    props:['show'],
    data() {
        return {
        }
    },
    methods:{
        share(opc){
            this.$emit('share',opc);
        },
        cancelar(){
            this.$emit('cancelar');
        }
    }
}

</script>

<style scoped>
.btn-redondo{
    display:block;
    width:60px;
    height:60px;
    line-height:60px;
    border: 2px solid #ebf9ff;
    border-radius: 50%;
    color:white;
    text-align:center;
    text-decoration:none;
    background: #1a2a36;
    /*box-shadow: 0 0 3px gray;*/
    font-size:20px;
    font-weight:bold;
    text-align: center;
    margin:auto;
}
.btn-redondo:hover{
    box-shadow: 0 0 3px #1a2a36;
}


.twitter{
    background-color: #1DA1F2 ;
}

.twitter:hover{
    box-shadow: 0 0 3px #1DA1F2;
}

.facebook{
    background-color: #4267B2 ;
}

.facebook:hover{
    box-shadow: 0 0 3px #4267B2;
}

.whats{
    background-color: #00E676 ;
}

.whats:hover{
    box-shadow: 0 0 3px #00E676;
}


</style>